import { render, staticRenderFns } from "./SearchMessage.vue?vue&type=template&id=72c9b2bc&"
import script from "./SearchMessage.vue?vue&type=script&lang=js&"
export * from "./SearchMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports